import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { IRecommendOrder } from './RecommendOrder';
import { IYearMonth } from '@/coreDomainsModule/date';

/**
 * 在庫が過剰か不足している適正かを表す
 */
export const InventoryCondition = {
  High: 'HIGH',
  Normal: 'NORMAL',
  Low: 'LOW',
};
/**
 * 在庫が過剰か不足している適正かを表す
 */
export type InventoryCondition = (typeof InventoryCondition)[keyof typeof InventoryCondition];

/**
 * 関連する取引をまとめたオブジェクト
 */
export type IParentBusiness = Omit<IBusiness, 'recommend'> & {
  aggregateGroup: string[];
  childrenAsyncStatus: 'loading' | 'loaded' | 'error' | 'none';
  children: IBusiness[];
  editData: {
    amount: number;
    date: Date;
  };
  recommend: IRecommendOrder[];
  inventoryConditionAtExecutionDate: InventoryCondition;
  recommendEstimateTime?: Date;
  recommendArrivalValue?: number;
};

/**
 * IParentBusinessに置き場移動に必要な情報を追加したオブジェクト
 */
export type IParentBusinessWithMoveWarehouse = IParentBusiness & {
  differenceOccurrenceMonthYear: IYearMonth;
  differenceAmount: number;
};

/**
 * 対象のIBusinessオブジェクトがIParentBusinessオブジェクトかどうかの判定を行う
 * 必ず、引数として受け取るオブジェクトはIBusinessの定義を満たしていることとする
 * @param value - IBusinessまたはIBusinessを拡張した情報
 */
export const isIParentBusiness = (value: IBusiness): value is IParentBusiness => {
  return (
    value != null &&
    typeof value === 'object' &&
    'aggregateGroup' in value &&
    'childrenAsyncStatus' in value &&
    'children' in value &&
    'editData' in value &&
    'recommend' in value
  );
};
